
// import HeaderComponent from '../../../navigation/HeaderComponent';
import { store } from '../../../configureStore';
import orm from '../../../orm';
import { appShowWebNavigationBarSelector } from '../../app/selectors';
import NavBarComponent from '../../navNode/NavBarComponent';
// import { useNavigate } from 'react-router-dom';
// import { Button } from 'bootstrap';

const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

type Props = {
  // navigation: any;
  navNodeId: string;
};

const PageComponent = (props: Props) => {
  debugLog('Component: PageComponent with props: ' + JSON.stringify(props, null, 4));

  const { navNodeId } = props;

  const session = orm.session(store.getState().orm);
  const { Experience, NavNode, Page } = session;
  // @ts-ignore
  const navNode = NavNode.withId(navNodeId);
  const contentId = navNode.contentId;
  const experienceId = navNode.experienceId;
  // @ts-ignore
  const experience = Experience.withId(experienceId);

  debugLog('P2 - PageComponent');
  debugLog('PageComponent - navNodeId : ' + navNodeId);
  debugLog('PageComponent - navNode: ' + JSON.stringify(navNode, null, 2));
  debugLog('PageComponent - contentId : ' + contentId);
  debugLog('PageComponent - experienceId : ' + experienceId);
  debugLog('PageComponent - experience : ' + JSON.stringify(experience, null, 2));

  // @ts-ignore
  const page = Page.withId(contentId);
  const pageFilePath = page.pageFilePath;
  debugLog('P3 - PageComponent');
  debugLog('PageComponent - page : ' + JSON.stringify(page, null, 2));
  debugLog('PageComponent - pageFilePath : ' + JSON.stringify(pageFilePath, null, 2));
  const pageAbsoluteUrl = 'http://process.env.EXPERIENCE_CONTENT_BASE_URL/' + pageFilePath;

  const pageURL = `${process.env.REACT_APP_EXPERIENCE_CONTENT_BASE_URL}/contents/page/${navNode.contentId}/index.html`;
  debugLog('pageURL : ' + pageURL);

  // 
  const showWebNavigationBar = appShowWebNavigationBarSelector(store.getState());
  debugLog('PageComponent - showWebNavigationBar : ' + JSON.stringify(showWebNavigationBar, null, 2));

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: window.innerHeight,
      width: window.innerWidth,
      // border: '1px solid red',
    }}>

      <div style={{
        flexGrow: 0,
        // border: '1px solid green',
      }}>
      { showWebNavigationBar &&
        <NavBarComponent navNodeId={navNodeId} showBrandNameSettings={false} showGoBack={false} showSettings={false} showSharing={false} title={''} />
      }
      </div>

      <iframe
        id="iFrameExample"
        title="iFrame Example"
        src={`${pageURL}`}
        width={window.innerWidth}
        style={{
          flexGrow: 1,
        }}
      >
      </iframe>

    </div>
  );
};

export default PageComponent;
